import { useMemo } from 'react';
import { calculateChatPosition, ChatState } from '@/utils/chatPositioning';

export function useChatPositioning(
  chatIndex: number = 0, 
  isMinimized: boolean = false,
  isExpanded: boolean = false,
  isChatListExpanded: boolean = true,
  previousChatStates: Array<{ isMinimized: boolean; isExpanded?: boolean }> = []
) {
  const position = useMemo(() => {
    // Convert to ChatState format
    const simplifiedPreviousStates: ChatState[] = previousChatStates.map(state => ({
      isMinimized: state.isMinimized,
      isExpanded: state.isExpanded || false,
    }));
    
    const currentState: ChatState = { isMinimized, isExpanded };
    
    return calculateChatPosition(
      chatIndex,
      currentState,
      isChatListExpanded,
      simplifiedPreviousStates
    );
  }, [chatIndex, isMinimized, isExpanded, isChatListExpanded, previousChatStates]);

  return position;
}